module.exports = __webpack_public_path__ + "static/media/pti.ac4085b2.png";